import { getTrackingSection } from '@/modules/misc/common/navbar/utils/trackingSection';
import { USER_TYPE } from '@/modules/misc/common/navbar/utils/types';
import { CALLUM_PHOTO, getAreaPrefill, onceVisible, withPrefill } from '@/modules/public/shared/concierge/concierge';

const COPY_BY_USER_TYPE = {
  [USER_TYPE.GUEST]: ['Planning a business event?', 'Let our Concierge handle it'],
  [USER_TYPE.USER]: ['Talk to a venue expert', 'We search and negotiate for you'],
};

let visibleTracked = false;
let stopWatchingVisibility = () => {};

function track(user, interaction) {
  App.track.event('navbar_interaction', {
    section: getTrackingSection(user.type),
    element: 'concierge_button',
    element_value: '',
    interaction,
  });
}

function createLink(user, [title, subtitle]) {
  const link = document.createElement('a');
  link.className = 'ds-header__concierge';
  link.href = withPrefill(user.concierge.howItWorksUrl, getAreaPrefill());
  link.target = '_blank';
  link.rel = 'noopener';
  link.innerHTML = `
    <span class="ds-header__concierge__avatar">
      <img src="${CALLUM_PHOTO}" alt="" width="28" height="28">
      <span class="ds-header__concierge__online"></span>
    </span>
    <span class="ds-header__concierge__copy">
      <span class="ds-header__concierge__title">${title}</span>
      <span>${subtitle}</span>
    </span>
  `;

  link.addEventListener('click', () => {
    // The search page keeps updating the area as the Client moves the map, so read it on click. The
    // landing page passes it on to the brief it opens.
    link.href = withPrefill(user.concierge.howItWorksUrl, getAreaPrefill());
    track(user, 'click');
  });

  return link;
}

// Pages that belong to a market declare it and offer the Concierge only in its market. The client
// cabinet and the blog belong to none, so they go by the market of the Client's latest enquiry, or by
// the country the visitor is in when there is none. With neither known, it is offered.
export function isConciergeOffered(user) {
  if (!user.concierge) {
    return false;
  }

  const market = window.__TGV_ISO_COUNTRY_CODE || user.concierge.clientMarket || user.locationCountryCode;

  return !market || market === user.concierge.market;
}

// Re-run with the rest of the navbar on breakpoint changes and login, so it replaces its own link.
// "visible" is reported once, when a link is first on screen: the CSS hides it on narrow screens and
// while another Concierge promo is on the page, which the page's Vue app may render after the navbar.
export function createConciergeEntry(user) {
  stopWatchingVisibility();
  document.querySelector('.ds-header__concierge')?.remove();

  const copy = COPY_BY_USER_TYPE[user.type];
  const headerMain = document.querySelector('.ds-header__main');

  if (!isConciergeOffered(user) || !copy || !headerMain) {
    return;
  }

  const link = createLink(user, copy);
  headerMain.appendChild(link);

  if (!visibleTracked) {
    stopWatchingVisibility = onceVisible(link, () => {
      visibleTracked = true;
      track(user, 'visible');
    });
  }
}
